<script setup>
import { computed } from 'vue'

import ValueInput from '@/components/input/valueInput.vue'

defineProps({
  size: {
    type: String,
    default: 'md',
    validators: value => ['sm', 'md', 'lg'].includes(value),
  },
  label: {
    type: String,
    required: false,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const model = defineModel({ type: [Number, String], default: 0 })

const reaisValue = computed({
  get: () => (model.value ? Number(model.value) / 100 : 0),
  set: newValue => {
    model.value = Math.round(Number(newValue) * 100)
  },
})
</script>

<template>
  <ValueInput :name="name" :label="label" :size="size" :disabled="disabled" v-model="reaisValue" />
</template>
